/**
 * Feature Article Columns & Rows Component
 *
 * Manages the display of post feed articles with a featured article layout.
 * - If no Component Body is used, separates the first article as the feature item
 * - Initializes Slick slider on the remaining items in a 2x2 grid
 * - Uses existing prev/next arrows rendered with the component
 * - Handles responsive behavior between desktop and mobile layouts
 */

// Import slick-carousel to extend jQuery
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

import { SELECTORS } from './constants';
import FeatureArticleComponent from './FeatureArticleComponent';

/**
 * Initializes all feature article components on the page
 */
const initializeFeatureArticle = (): void => {
    const components = $(SELECTORS.COMPONENT);

    components.each(function(this: HTMLElement): void {
        const component = $(this);

        // Skip if already initialized
        if (component.data('featureArticleInitialized')) {
            return;
        }

        const featureArticle = new FeatureArticleComponent(component);
        featureArticle.initialize();

        // Mark as initialized and store reference for cleanup
        component.data('featureArticleInitialized', true);
        component.data('featureArticleInstance', featureArticle);
    });
};

// Initialize on document ready
$(document).ready((): void => {
    initializeFeatureArticle();
});

// Cleanup on page unload
$(window).on('beforeunload', (): void => {
    $(SELECTORS.COMPONENT).each(function(this: HTMLElement): void {
        const instance = $(this).data('featureArticleInstance') as FeatureArticleComponent | undefined;
        if (instance && typeof instance.cleanup === 'function') {
            instance.cleanup();
        }
    });
});

export default initializeFeatureArticle;

